import { render, staticRenderFns } from "./MyTabPane.vue?vue&type=template&id=2b09d83a&scoped=true&"
import script from "./MyTabPane.vue?vue&type=script&lang=ts&"
export * from "./MyTabPane.vue?vue&type=script&lang=ts&"
import style0 from "./MyTabPane.vue?vue&type=style&index=0&id=2b09d83a&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b09d83a",
  null
  
)

export default component.exports